var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4197 3.22362C13.3166 1.32769 16.2633 1.25908 18.0175 2.92825L18.0924 3.00319C19.8368 4.74844 19.7944 7.75372 17.8704 9.67692L17.8703 9.67706L10.5303 17.0179L3.18939 9.67703C1.2662 7.75383 1.22381 4.74858 2.96908 3.00331L2.96932 3.00307C4.71331 1.2575 7.71833 1.3001 9.64279 3.22363C9.64283 3.22366 9.64287 3.2237 9.64291 3.22374L10.0009 3.58175L10.5313 4.11208L11.0616 3.58175L11.4196 3.22374C11.4196 3.2237 11.4197 3.22366 11.4197 3.22362Z",
    stroke: "#113E2E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.2529f261bb68bfea9173ed58491cb532.svg";
export { ForwardRef as ReactComponent };